import Pagination from "@amzn/meridian/pagination";
import Row from "@amzn/meridian/row";
import React, {useEffect, useState} from "react";
import {chainWalk} from "../util/Util";
import Table from "@amzn/meridian/table";
import Column from "@amzn/meridian/column";
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";

const PaginatedTable = ({data, renderRow, renderHeader, renderSearchRow, onSort, sortColumn, sortDirection, numberOfRowsPerPage = 20}) => {
    const [pageCount, setPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const totalRows = chainWalk(() => data.length, 0);
        const totalPages = Math.ceil(totalRows/numberOfRowsPerPage);
        setPageCount(totalPages);
    });

    const startIndex = (currentPage-1)*numberOfRowsPerPage;
    const endIndex = currentPage*numberOfRowsPerPage;

        return (
            <Column>
                <Table
                    headerRows={1}
                    spacing="small"
                    showDividers={true}
                    showStripes={true}
                    sortColumn={sortColumn}
                    sortDirection={sortDirection}
                    onSort={onSort}
                >
                    {renderHeader()}
                    {renderSearchRow && renderSearchRow()}
                    {
                        data.slice(startIndex, endIndex).map((instance, index) =>
                            renderRow(instance, startIndex + index + 1, index))
                    }
                </Table>
                { (pageCount === 0) &&
                    <Alert type="informational" size="small">
                    <FormattedMessage id="table.nodata"
                    defaultMessage="No data present"/>
                    </Alert>
                }
                <Row alignmentHorizontal="center">
                    <Pagination onChange={setCurrentPage} currentPage={currentPage} numberOfPages={pageCount}/>
                </Row>
            </Column>
        )
}

export default PaginatedTable;



// WEBPACK FOOTER //
// ./src/components/commonui/PaginatedTable.js